export default "__VITE_ASSET__CmvaFXaL__"